import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { Settings } from './pages/Settings';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { LoggedOut } from './pages/LoggedOut';
import { AdminDashboard } from './pages/AdminDashboard';
import { Organizations } from './pages/Organizations';
import { Users } from './pages/Users';
import { Surveys } from './pages/Surveys';
import { SurveyRespondents } from './pages/SurveyRespondents';
import { SurveyResponse } from './pages/SurveyResponse';
import { CampaignResponse } from './pages/CampaignResponse';
import { CampaignRespondents } from './pages/CampaignRespondents';
import { SurveyReport } from './pages/SurveyReport';
import { Library } from './pages/Library';
import { Reports } from './pages/Reports';
import { Support } from './pages/Support';
import { Search } from './pages/Search';
import { Strategy } from './pages/Strategy';
import { Tools } from './pages/Tools';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <OrganizationProvider>
            <SidebarProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/logged-out" element={<LoggedOut />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/organizations"
                  element={
                    <ProtectedRoute adminOnly>
                      <Organizations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute adminOnly>
                      <Users />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/surveys"
                  element={
                    <ProtectedRoute>
                      <Surveys />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/surveys/:id/respondents"
                  element={
                    <ProtectedRoute>
                      <SurveyRespondents />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/surveys/:surveyId/respond/:respondentId"
                  element={<SurveyResponse />}
                />
                <Route
                  path="/campaigns/:id/respondents"
                  element={
                    <ProtectedRoute>
                      <CampaignRespondents />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/campaigns/:campaignId/respond/:respondentId"
                  element={<CampaignResponse />}
                />
                <Route
                  path="/reports/:surveyId"
                  element={
                    <ProtectedRoute>
                      <SurveyReport />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/library"
                  element={
                    <ProtectedRoute>
                      <Library />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute>
                      <Reports />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/strategy"
                  element={
                    <ProtectedRoute>
                      <Strategy />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tools"
                  element={
                    <ProtectedRoute>
                      <Tools />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/support"
                  element={
                    <ProtectedRoute>
                      <Support />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/search"
                  element={
                    <ProtectedRoute>
                      <Search />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </SidebarProvider>
          </OrganizationProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;